<div class="table--grid">
    <div class="table--grid__header">
        <div class="table--grid__header-tab"
             *ngFor="let page of PAGES"
             (click)="navigate(page)"
             [class.active]="currentPage === page['key']">
            <div>
                {{ page['title'] | translate }}
            </div>
        </div>
    </div>
</div>